import React from 'react';
import { ButtonProps } from 'src/components/ui/Button/Button';
import classNames from 'classnames';
import Header from '../Header/Header';

export type ContainerProps = {
  children: React.ReactNode;
  buttons?: ButtonProps[];
  title?: string;
  className?: string;
  isEditMode?: boolean;
  editAction?: () => void;
  hint?: string;
};

export const Container: React.FC<ContainerProps> = ({
  children,
  buttons,
  title,
  className = '',
  isEditMode,
  editAction,
  hint,
}: any) => {
  // The auth check that used to live here is gone. It ran after *every* render
  // (no dependency array) and navigated to the **relative** '../login', which
  // from the doubly nested routes (warehouse/inbound/*, returns/*) resolved to
  // e.g. '/warehouse/inbound/login' — a path that still matches '/*', so <Auth>
  // rendered nothing and nothing corrected the URL: a blank page until a manual
  // reload. Every Container is rendered inside <Auth>, which now owns the token
  // check and redirects on an absolute path.
  return (
    <>
      <Header title={title} buttons={buttons} isEditMode={isEditMode} editAction={editAction} hint={hint} />
      <div className={classNames(className, 'Container px-20 py-32 md:p-32')}>{children}</div>
    </>
  );
};
